import React, { useEffect, useState } from "react";

const ProgressBarTimer = () => {
  const TOTAL_TIME = 60 * 5;
  const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  const progress = ((TOTAL_TIME - timeLeft) / TOTAL_TIME) * 100;

  // color logic
  const getColor = () => {
    if (timeLeft > 40) return "#dc3545"; // red
    if (timeLeft > 20) return "#ffc107"; // yellow
    return "#28a745";                   // green
  };

  return (
    <div style={styles.container}>

      {/* Moving bar */}
      <div
        style={{
          ...styles.bar,
          width: `${progress}%`,
          backgroundColor: getColor(),
        }}
      ></div>

      {/* Fixed centered text */}
      <span style={styles.text}>
        Important to have a long, non-business, meaningful conversation here to
        get to know your client better!
      </span>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    height: "28px",
    backgroundColor: "#e9ecef",
    borderRadius: "8px",
    overflow: "hidden",
    position: "relative",
  },
  bar: {
    height: "100%",
    transition: "width 1s linear",
    position: "absolute",
    left: 0,
    top: 0,
    zIndex: 1,
  },
  text: {
    zIndex: 2,
    position: "absolute",
    width: "100%",
    textAlign: "center",
    fontWeight: "bold",
    color: "#000",
    padding: "5px 8px",
    fontSize: "13px",
  },
};

export default ProgressBarTimer;
